<template>
  <span>
    <el-popconfirm v-if="!copyFlag" title="信息已隐藏，确定要查看？" @confirm="handleView">
      <span slot="reference" :class="channel == 92 ? (copyFlag ? '' : 'link') : ''">{{
        row[rowKey]
      }}</span>
    </el-popconfirm>
    <span v-else :class="channel == 92 ? (copyFlag ? '' : 'link') : ''">{{ row[rowKey] }}</span>
    <BjCopyIcon v-if="copy && copyFlag && row[rowKey]" :copy="row[rowKey]" />
  </span>
</template>
<script>
import { getEnvGlobalConfig, toLine } from '@/utils';
import { ajax } from '@/utils/request';
import { orderApi } from '@/api';
export default {
  name: 'BjDecrypt',
  props: {
    // 把对象传进来获取数据之后修改对象里的地址，防止数据还原成带*号的数据
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },
    rowKey: {
      type: String,
      default: null,
    },
    /**
     * receiverPhone:收货人手机号
     * receiverName:收货人姓名
     * receiverAddress:收货人地址
     * cardnum:收货人身份证号
     * cardname:收货人身份证姓名
     * address:收货人的详细地址
     */
    type: {
      type: String,
      default: 'receiverAddress',
      validator: value => {
        return [
          'receiverPhone',
          'receiverName',
          'receiverAddress',
          'cardnum',
          'cardname',
          'address',
        ].includes(value);
      },
    },
    // 需要解密的数据所属的订单编号。
    orderSn: {
      type: [String, Number],
      default: null,
    },
    copy: {
      type: Boolean,
      default: false,
    },
    channel: {
      type: [String, Number],
      default: null,
    },
    // 是否通过内部单查询
    inner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      message: null,
      url: '/pdd/control/decrypt/v1/',
      data: {
        decrypt_set: {
          sub_msg: {},
          sub_code: null,
        },
        decrypt_report_type: null,
        request_id: null,
        page_table_id: null,
        order_sn: this.orderSn,
      },
      decryptObj: {
        receiverPhone: 'receiverPhoneEncrypt',
        receiverName: 'receiverNameEncrypt',
        receiverAddress: 'receiverAddressEncrypt',
      },
      // 判断数据是否可以拷贝
      copyFlag: false,
    };
  },
  computed: {
    api() {
      // 判断来源状态是否是复制单
      // return this.row.actionType === '202'
      //   ? orderApi.getEncryptReceiverInfo
      //   : thirdApi.getThirdPartyOrderEncryptReceiverInfo;
      return orderApi.getEncryptReceiverInfo;
    },
  },
  mounted() {},
  methods: {
    async handleView() {
      if (this.channel != 92) return;
      const OBJ = {};
      const KEY = this.inner ? 'innerOrderNo' : 'outOrderNo';
      OBJ[KEY] = this.orderSn;
      const res1 = await this.api(OBJ);
      if (res1) {
        this.data.order_sn = res1.outOrderNo;
        this.data.decrypt_set.sub_msg = JSON.stringify({
          msg: res1[this.decryptObj[this.type]],
          mallId: res1.mallId,
        });
      }
      // mallId不存在不用调用第三方接口
      if (!res1.mallId) {
        const info = res1[this.decryptObj[this.type]];
        this.row[this.rowKey] = info || this.row[this.rowKey];
        this.copyFlag = !!info;
        // if (!this.copyFlag) this.msgError('获取失败');
      } else {
        // 判断链接是否存在风控需要的 verifyAuthToken
        let header = {
          'X-PDD-VerifyAuthToken': sessionStorage.getItem('verifyAuthToken'),
        };
        if (!header['X-PDD-VerifyAuthToken']) header = {};
        // 测试风控使用此代码 // header = { 'X-PDD-MustVerify': 'True' };
        const API = getEnvGlobalConfig('VUE_APP_PDD_CLOUD_URL') + this.url + this.type;
        const res2 = await ajax('post', API, { data: this.data }, header);
        // 出现风控
        if (res2.error_code === 54001) {
          // 获取跳转风控页面相关参数
          const OBJ = {
            redirect_url: encodeURIComponent(
              window.location.origin + '/loading.html?back=' + location.hash.replace('#', ''),
            ), // encodeURIComponent(window.location.href)
            mall_id: res2.mall_id,
            client_id: res2.client_id,
            verifyAuthToken: res2.risk_info.verify_auth_token,
          };
          const LIST = [];
          // 参数拼接
          Object.keys(OBJ).forEach(key => {
            LIST.push(key + '=' + OBJ[key]);
          });
          // 风控链接完成，进行跳转
          const verifyUrl = getEnvGlobalConfig('VUE_APP_PDD_CLOUD_RISK_URL') + '?' + LIST.join('&');
          window.location.href = verifyUrl;
          return;
        }
        if (res2.order_info[toLine(this.type)]) {
          this.row[this.rowKey] = res2.order_info[toLine(this.type)];
          this.copyFlag = true;
        } else {
          this.copyFlag = false;
        }
      }
    },
  },
};
</script>
<style scoped></style>
